"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 20.25a8.2 8.2 0 0 1-5.834-2.417A8.2 8.2 0 0 1 3.75 12a8.2 8.2 0 0 1 2.417-5.833A8.2 8.2 0 0 1 12 3.75a8.2 8.2 0 0 1 5.833 2.417A8.2 8.2 0 0 1 20.25 12a8.2 8.2 0 0 1-2.416 5.834A8.2 8.2 0 0 1 12 20.25m-3.099-4.643a4.82 4.82 0 0 0 6.556-.249 4.83 4.83 0 0 0 1.414-3.408.6.6 0 0 0-1.198 0 3.63 3.63 0 0 1-3.627 3.626 3.62 3.62 0 0 1-2.322-.841h.324a.6.6 0 0 0 0-1.2H8.3a.6.6 0 0 0-.6.6v1.749a.6.6 0 0 0 1.199 0v-.277zm3.149-8.48a4.83 4.83 0 0 0-4.824 4.822.6.6 0 0 0 1.2 0 3.63 3.63 0 0 1 3.625-3.626c.85 0 1.671.297 2.322.842h-.323a.6.6 0 0 0 0 1.198h1.748a.6.6 0 0 0 .6-.6V8.016a.6.6 0 0 0-1.199 0v.276a4.82 4.82 0 0 0-3.149-1.165"
}), 'ReplaceFilled');
//# sourceMappingURL=index.js.map